
		import * as m from "/home/vincentfretin/workspace/handy-work/src/handpose.js";
		import {expose} from "comlink";

		expose(m);
	